import { FunctionComponent, useMemo } from "react";

import {
  DatePickerField,
  DropdownField,
  TextInputField,
  FieldSpy,
  IDropdownOption,
  useFormContext
} from "@bps/fluent-ui";
import {
  ApplicationDto,
  CloudApplicationSecret
} from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.dtos";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";

export interface CreateSecretFormProps {
  application: ApplicationDto;
  tenant: Tenant;
  onDismiss: () => void;
}

const expiryDateOptions: IDropdownOption[] = [
  { key: "3", text: "90 days (3 months)" },
  { key: "6", text: "180 days (6 months)" },
  { key: "12", text: "365 days (12 months)" },
  { key: "24", text: "730 days (24 months)" },
  { key: "Custom", text: "Custom" }
];

export const CreateSecretForm: FunctionComponent<CreateSecretFormProps> = () => {
  const {
    actions: { setValue },
    state: { values }
  } = useFormContext<CloudApplicationSecret>();

  const startDateTime = useMemo(() => values.startDateTime, [values]);

  return (
    <>
      <TextInputField name="displayName" label="Description" required />
      <DropdownField
        name="expires"
        placeholder="Expires"
        label="Expires"
        options={expiryDateOptions}
      />
      <FieldSpy<string>
        name="expires"
        onChange={key => {
          if (key !== "Custom") {
            const endDateUpdated = new Date(startDateTime);
            endDateUpdated.setMonth(startDateTime.getMonth() + parseInt(key!));

            setValue("endDateTime", endDateUpdated);
          }
        }}
      />
      <DatePickerField
        required
        label="Start"
        name="startDateTime"
        minDate={new Date()}
      />
      <DatePickerField
        required
        label="End"
        name="endDateTime"
        minDate={new Date()}
        maxDate={
          new Date(
            startDateTime!.getFullYear() + 2,
            startDateTime!.getMonth(),
            startDateTime!.getDay()
          )
        }
      />
    </>
  );
};
